import { toast } from "react-toastify";
import { observable } from "mobx";
import { apiOperacao } from "../../api";
import moment from "moment";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";

export class _SpedTransmissaoStore {
  obs = observable({
    tasks_sped: [] as any[],
    length_tasks_sped: 0 as number,
    loading: false as boolean,
    loadingImport: false as boolean,
  })

  async handleTasksPaged(paged: number, cnpj: string, data_agendamento: any, tipo: string) {

    let data = data_agendamento && data_agendamento.$d ? data_agendamento.$d : null

    if (!data || moment(data).format("YYYY-MM-DD") == "Data inválida") {
      data = null
    } else {
      data = moment(data).format("YYYY-MM-DD")
    }

    let params = {
      page: paged,
      limit: 15,
      cnpj: (!cnpj ? null : cnpj),
      data_agendamento: data,
      tipo: (tipo || null)
    }

    try {

      let resp = await apiOperacao("sped").post("/sped/transmissoes/index", params);

      this.obs.tasks_sped = [];
      this.obs.length_tasks_sped = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_sped = resp.data.itens;
        this.obs.length_tasks_sped = resp.data.count
      }

    } catch (ex) { }

  }

  async handleCreateTransmissao(params) {

    try {

      let resp = await apiOperacao("sped").post("/sped/transmissoes/create", params);

      if (resp.data.ok) {

        toast.success('Solicitação realizada com sucesso', {});

        return true;

      } else {

        toast.error(resp.data.erro, {});

      }

    } catch (ex) { }

    return false;

  }

  async handleDownloadRelatorio(id: string, cnpj: string) {

    this.obs.loading = true

    try {

      let resp = await apiOperacao("sped").get(`/sped/transmissoes/download/${id}`, {
        responseType: 'arraybuffer'
      });

      if (resp.status == 200) {

        const fileName = cnpj + ".pdf";

        downloadBinaryFile(resp.data, fileName);

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) { }

    this.obs.loading = false

  }

  async handleDownloadArquivoSped(id: string, cnpj: string) {

    this.obs.loading = true

    try {

      let resp = await apiOperacao("sped").get(`/sped/task/download/${id}`);

      if (resp.data.ok) {

        const linkSource = `data:application/txt;base64,${resp.data.file}`;
        const downloadLink = document.createElement("a");
        const fileName = cnpj + "_Sped.txt";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.error('erro ao baixar o arquivo, tente novamente mais tarde ou contate o suporte.', {});

      }

    } catch (ex) { }

    this.obs.loading = false

  }

  async handldeCreateTaskImport(data) {

    this.obs.loadingImport = true

    try {

      let resp = await apiOperacao("sped").post("/sped/transmissoes/import", data);

      if (resp.data.ok) {

        toast.success('Importado com sucesso!', {});

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) {

      toast.error("Erro ao realizar importação, tente novamente mais tarde.", {});

    }

    this.obs.loadingImport = false

  }

}

export const SpedTransmissaoStore = new _SpedTransmissaoStore();
